var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Vue, Prop, } from "vue-property-decorator";
import ModalBase from "../../components/modalbase.vue";
import { createCircle, createRectangle, } from "../utilities/geometry";
import { createSheetMetalProfile, createSvg, PartType, } from "../utilities/partcreation";
import { sheetMetalProfileParts, } from "../utilities/profilecreation";
import { TubeProfileGeometryType, } from "../utilities/wsi4_interfaces";
let PartCreationSelectionDialog = class PartCreationSelectionDialog extends Vue {
    close() { }
    openPartCreation(type) {
        this.close();
        return type;
    }
    svgClass(type) { return "svg-" + type; }
    get partTypeOptions() {
        const options = [];
        if (this.networkBroker.configuration.partCreationConfig.circleCutout) {
            options.push({
                icon: createSvg({
                    outerPolygon: createCircle(50.),
                    innerPolygons: [],
                }, {
                    addMeasurements: false,
                    profileParts: [],
                }),
                partType: PartType.circleCutout,
            });
        }
        if (this.networkBroker.configuration.partCreationConfig.rectangleCutout) {
            options.push({
                icon: createSvg({
                    outerPolygon: createRectangle(200., 100., 5.),
                    innerPolygons: [],
                }, {
                    addMeasurements: false,
                    profileParts: [],
                }),
                partType: PartType.rectangleCutout,
            });
        }
        if (this.networkBroker.configuration.partCreationConfig.sheetMetalProfile) {
            options.push({
                icon: createSvg({
                    outerPolygon: createSheetMetalProfile(sheetMetalProfileParts([
                        {
                            innerAngleInDegrees: 90.,
                            ccw: false,
                            flangeLength: 8.,
                        },
                        {
                            innerAngleInDegrees: 55.,
                            ccw: true,
                            flangeLength: 10.,
                        },
                        {
                            innerAngleInDegrees: 0.,
                            ccw: true,
                            flangeLength: 6.,
                        },
                    ], 1.), 1.),
                    innerPolygons: [],
                }, {
                    addMeasurements: false,
                    profileParts: [],
                }),
                partType: PartType.sheetMetalProfile,
            });
        }
        if (this.networkBroker.configuration.partCreationConfig.userDefinedTube) {
            if (this.shopConfig.tubeProfiles.length === 0) {
                throw Error("Missing tube profiles.");
            }
            const htmlElement = document.createElement("div");
            htmlElement.className = "tubes";
            const dp = new DOMParser();
            const rectangularTubes = this.shopConfig.tubeProfiles.filter(t => t.geometryType === TubeProfileGeometryType.rectangular);
            if (rectangularTubes.length !== 0) {
                rectangularTubes.sort((a, b) => a.geometry.thickness < b.geometry.thickness ? -1 : a.geometry.thickness === b.geometry.thickness ? 0 : 1);
                const rectangluarTube = rectangularTubes[rectangularTubes.length - 1];
                const s = dp.parseFromString(rectangluarTube.svg, "image/svg+xml").documentElement;
                for (const child of s.children) {
                    child.setAttribute("stroke-width", "5");
                }
                htmlElement.appendChild(s);
            }
            const circularTubes = this.shopConfig.tubeProfiles.filter(t => t.geometryType === TubeProfileGeometryType.circular);
            if (circularTubes.length !== 0) {
                circularTubes.sort((a, b) => a.geometry.thickness < b.geometry.thickness ? -1 : a.geometry.thickness === b.geometry.thickness ? 0 : 1);
                const circularTube = circularTubes[circularTubes.length - 1];
                const s = dp.parseFromString(circularTube.svg, "image/svg+xml").documentElement;
                for (const child of s.children) {
                    child.setAttribute("stroke-width", "5");
                }
                htmlElement.appendChild(s);
            }
            options.push({
                partType: PartType.userDefinedTube,
                icon: htmlElement,
            });
        }
        return options;
    }
    mounted() {
        for (const o of this.partTypeOptions) {
            if (o.icon === undefined) {
                continue;
            }
            const s = this.$el.querySelector("." + this.svgClass(o.partType));
            if (s === undefined || s === null) {
                throw Error("Selector ." + this.svgClass(o.partType) + " does not match");
            }
            s.appendChild(o.icon);
        }
    }
};
__decorate([
    Prop({ required: true })
], PartCreationSelectionDialog.prototype, "shopConfig", void 0);
__decorate([
    Inject()
], PartCreationSelectionDialog.prototype, "i18n", void 0);
__decorate([
    Inject()
], PartCreationSelectionDialog.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], PartCreationSelectionDialog.prototype, "close", null);
__decorate([
    Emit()
], PartCreationSelectionDialog.prototype, "openPartCreation", null);
PartCreationSelectionDialog = __decorate([
    Component({
        components: {
            ModalBase,
        },
        name: "PartCreationSelectionDialog",
    })
], PartCreationSelectionDialog);
export default PartCreationSelectionDialog;
